import {useEffect, useState} from 'react';
import {useGetLoggedInUserQuery} from "@mwServices/User";

const useHasPermission = (permission: string) => {
    const loggedInQuery = useGetLoggedInUserQuery();

    const testPermission = () => {
        let check = false;
        if(loggedInQuery && loggedInQuery.data){
            const user = loggedInQuery.data.user;
            if(user && user.permissions)
            {
                check = !!user.permissions[permission] || user.permissions.rules.includes(permission);
            }
        }
        return check;
    };

    const [hasPermission, setHasPermission] = useState<boolean>(testPermission() );

    useEffect(() => {
        let check = testPermission();
        if(check !== hasPermission)  setHasPermission(check);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loggedInQuery.data])

    return hasPermission;
}

export default useHasPermission;